import React from 'react';
import classnames from 'classnames';

import { buttonColor, buttonSize } from 'shared/ui/Button/ButtonTypes';

type Props = {
  color?: buttonColor;
  size?: buttonSize;
  isBlock?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button: React.FC<Props> = ({ color, size, className, type = 'button', isBlock, ...props }) => {
  const wrapperClassName = classnames(className, 'btn', {
    [`btn-${size}`]: !!size,
    'btn-block': !!isBlock,
    [`btn-${color}`]: !!color,
  });

  // eslint-disable-next-line react/button-has-type
  return <button {...props} type={type} className={wrapperClassName} />;
};
